import { makeStyles, Typography } from '@material-ui/core';
import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
} from '@backstage/plugin-techdocs-react';

import FeedbackIcon from '@material-ui/icons/Feedback';

const EDIT_LINK_SELECTOR = '[title^="Edit this page"]';

const useHasEditUri = () => {
  const [editLink] = useShadowRootElements([EDIT_LINK_SELECTOR]);
  return !!editLink;
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 2, 2, 2),
    height: '120px',
    marginBottom: '16px',
    border: '1px solid var(--arla-card-divider-color)',
    borderRadius: '4px',
  },
  headerIconContainer: {
    display: 'flex',
  },
  primarySidebarSpacer: {
    paddingTop: theme.spacing(2),
    height: '120px',
    marginBottom: '16px',
  },
  heading: {
    fontSize: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  body: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
}));

const FeedbackSidebarAddonComponent = () => {
  const classes = useStyles();
  const hasEditUri = useHasEditUri();

  if (!hasEditUri) return null;

  return (
    <div className={classes.root}>
      <div className={classes.headerIconContainer}>
        <Typography className={classes.heading}>
        Feedback for this documentation?
      </Typography>
        <FeedbackIcon color="primary" fontSize="small" />
      </div>
      <Typography className={classes.body}>
        Simply highlight the text and create an issue on GitHub.
      </Typography>
    </div>
  );
};

const PrimarySidebarSpacerComponent = () => {
  const classes = useStyles();
  const hasEditUri = useHasEditUri();

  if (!hasEditUri) return null;

  return <div className={classes.primarySidebarSpacer} />;
};

const feedbackSidebarPlugin = createPlugin({
  id: 'techdocs-feedback-sidebar',
});

export const FeedbackSidebarAddon = feedbackSidebarPlugin.provide(
  createTechDocsAddonExtension({
    name: 'FeedbackSidebar',
    location: TechDocsAddonLocations.SecondarySidebar,
    component: FeedbackSidebarAddonComponent,
  }),
);

export const PrimarySidebarSpacer = feedbackSidebarPlugin.provide(
  createTechDocsAddonExtension({
    name: 'PrimarySidebarSpacer',
    location: TechDocsAddonLocations.PrimarySidebar,
    component: PrimarySidebarSpacerComponent,
  }),
);
